module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"departure":"Départ le","return":"Retour le","required":"Champs requis"},"en":{"departure":"Departure on","return":"Return on","required":"Required"}}')
  delete Component.options._Ctor
}
